module.exports = __webpack_public_path__ + "static/img/p1.257301f9.png";